// extracted by mini-css-extract-plugin
export default {"body":"Body_body__6OMB4","bannerContainer":"Body_bannerContainer__IFW5L"};